import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileTextIcon, DownloadIcon, PlusIcon } from 'lucide-react';
export function OutletReports() {
  const {
    t
  } = useTranslation('common');
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-7792">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8" data-id="element-7793">
        <div data-id="element-7794">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-7795">Reports</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-7796">
            Hierarchy-level report set and ad-hoc builder
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-7797">
          <button className="px-4 py-2 bg-[var(--brand-primary)] text-[var(--brand-primarytextonwhite)] text-sm font-medium rounded-lg hover:bg-[var(--brand-primaryhover)] transition-colors shadow-sm flex items-center gap-2" data-id="element-7798">
            <PlusIcon size={16} data-id="element-7799" />
            Build Report
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-7800">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:border-blue-300 transition-colors cursor-pointer group" data-id="element-7801">
          <div className="flex items-center justify-between mb-4" data-id="element-7802">
            <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center" data-id="element-7803">
              <FileTextIcon size={20} className="text-blue-600" data-id="element-7804" />
            </div>
            <button className="text-gray-400 hover:text-gray-600" data-id="element-7805">
              <DownloadIcon size={18} data-id="element-7806" />
            </button>
          </div>
          <h3 className="text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors" data-id="element-7807">
            Category Benchmark
          </h3>
          <p className="text-sm text-gray-500 mt-1" data-id="element-7808">
            Compare outlets against category peers in the same mall.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:border-blue-300 transition-colors cursor-pointer group" data-id="element-7809">
          <div className="flex items-center justify-between mb-4" data-id="element-7810">
            <div className="w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center" data-id="element-7811">
              <FileTextIcon size={20} className="text-green-600" data-id="element-7812" />
            </div>
            <button className="text-gray-400 hover:text-gray-600" data-id="element-7813">
              <DownloadIcon size={18} data-id="element-7814" />
            </button>
          </div>
          <h3 className="text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors" data-id="element-7815">
            Mall Rollup
          </h3>
          <p className="text-sm text-gray-500 mt-1" data-id="element-7816">
            Consolidated performance metrics for a specific property.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:border-blue-300 transition-colors cursor-pointer group" data-id="element-7817">
          <div className="flex items-center justify-between mb-4" data-id="element-7818">
            <div className="w-10 h-10 bg-purple-50 rounded-lg flex items-center justify-center" data-id="element-7819">
              <FileTextIcon size={20} className="text-purple-600" data-id="element-7820" />
            </div>
            <button className="text-gray-400 hover:text-gray-600" data-id="element-7821">
              <DownloadIcon size={18} data-id="element-7822" />
            </button>
          </div>
          <h3 className="text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors" data-id="element-7823">
            Settlement & Fees
          </h3>
          <p className="text-sm text-gray-500 mt-1" data-id="element-7824">
            Detailed fee statements with SST breakout per outlet.
          </p>
        </div>
      </div>
    </div>;
}